









































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { ComponentBase, FlatButton, Overlay } from '../components';
import { Comp, Dict, Utils } from '../types';


// region Типы
namespace ColumnItem {
    export interface Base {
        type: 'GROUP' | 'COLUMN';
        id: number;
        title: string;
        orderNumber: number;
        level: number;
        colSpan: number;
        data: (Dict.StRepFormColGroup | Dict.StRepFormCol);
        flcWarnings: Array<HierarchyFlcWarning>;
    }

    export interface Group extends Base {
        type: 'GROUP';
        data: Dict.StRepFormColGroup;
        children: Array<ColumnItem>;
    }

    export interface Column extends Base {
        type: 'COLUMN';
        data: Dict.StRepFormCol;
    }
}

type ColumnItem = ColumnItem.Group | ColumnItem.Column;

interface Hierarchy {
    maxLevel: number;
    items: Array<ColumnItem>;
    itemRows: Array<Array<ColumnItem>>;
}

interface HierarchyDataCollector {
    maxLevel: number;
    itemRows: Array<Array<ColumnItem>>;
}

namespace HierarchyFlcWarning {
    export interface Base {
        items: Array<ColumnItem>;
    }

    export interface EqualOrderNumber extends Base{
        type: 'EQUAL_ORDER_NUMBER';
        orderNumber: number;
    }

    export interface LeafGroup extends Base {
        type: 'LEAF_GROUP';
    }
}

type HierarchyFlcWarning = HierarchyFlcWarning.EqualOrderNumber | HierarchyFlcWarning.LeafGroup;
// endregion


const javaMaxInteger = 2147483647;


const translates = {
    get backToDictList(): string {
        return i18n.choose(
            'Назад к списку справочников',
            'Анықтамалық кітаптар тізіміне оралыңыз',
            'Back to dictionary list',
        );
    },
    column: {
        field: {
            get aggregation(): string {
                return i18n.choose(
                    'Код вида агрегации',
                    'Агрегация түрінің коды',
                    'Aggregation type code',
                );
            },
            get code(): string {
                return i18n.choose(
                    'Код колонки',
                    'Баған коды',
                    'Column code',
                );
            },
            get colGroup(): string {
                return i18n.choose(
                    'ID группы колонок',
                    'Баған тобының идентификаторы',
                    'Column group ID',
                );
            },
            get colType(): string {
                return i18n.choose(
                    'Тип колонки',
                    'Баған түрі',
                    'Column type',
                );
            },
            get dataSource(): string {
                return i18n.choose(
                    'Код источника данных',
                    'Мәліметтердің бастапқы коды',
                    'Data source code',
                );
            },
            get detailedReportOnly(): string {
                return i18n.choose(
                    'Признак "отображать только в расширенном отчете"',
                    '"Тек кеңейтілген есепте көрсету" жалаушасы',
                    'Flag "display only in extended report"',
                );
            },
            get forTotal(): string {
                return i18n.choose(
                    'Признак "Колонка для отправки в свод"',
                    '"Қаймаға жіберілетін баған" жалаушасы',
                    'Flag "Column to send to the vault"',
                );
            },
            get fractionalDigitCount(): string {
                return i18n.choose(
                    'Количество цифр в дробной части',
                    'Бөлшек бөлігіндегі цифрлар саны',
                    'Number of digits in the fractional part',
                );
            },
            get id(): string {
                return 'ID';
            },
            get nameKk(): string {
                return i18n.choose(
                    'Название на казахском',
                    'Аты қазақша',
                    'Name in kazakh',
                );
            },
            get nameRu(): string {
                return i18n.choose(
                    'Название на русском',
                    'Орысша атауы',
                    'Name in russian',
                );
            },
            get orderNumber(): string {
                return i18n.choose(
                    'Порядковый номер - для сортировки колонок внутри группы',
                    'Реттік нөмір – топ ішіндегі бағандарды сұрыптауға арналған',
                    'Sequence number - for sorting columns within a group',
                );
            },
            get removeIfNoData(): string {
                return i18n.choose(
                    'Признак "удалять колонку, если в ней нет данных"',
                    '«Деректер жоқ болса, бағанды жою» деп жалауша',
                    'Flag "delete column if it has no data"',
                );
            },
            reportTypes: {
                get title(): string {
                    return i18n.choose(
                        'Список типов отчетов, в которых будет использоваться колонка',
                        'Баған пайдаланылатын есеп түрлерінің тізімі',
                        'List of report types in which the column will be used',
                    );
                },
                values: {
                    get COMMON(): string {
                        return i18n.choose(
                            'обычный отчет',
                            'тұрақты есеп',
                            'common report',
                        );
                    },
                    get DETAILED(): string {
                        return i18n.choose(
                            'расширенный отчет',
                            'кеңейтілген есеп',
                            'detailed report',
                        );
                    },
                    get DEBUG(): string {
                        return i18n.choose(
                            'отладка',
                            'отладка',
                            'debugging',
                        );
                    },
                    get FZP_TOTAL(): string {
                        return i18n.choose(
                            'ФЗП - Всего',
                            'ФЗП - Барлығы',
                            'FZP - Total',
                        );
                    },
                    get FZP_CALC(): string {
                        return i18n.choose(
                            'ФЗП - Расчетные',
                            'ФЗП - Есеп айырысу',
                            'FZP - Calculated',
                        );
                    },
                    get FZP_NA(): string {
                        return i18n.choose(
                            'ФЗП - Новоприбывшие',
                            'ФЗП - Жаңадан келгендер',
                            'FZP - New arrivals',
                        );
                    },
                },
            },
            get subprogDistEditable(): string {
                return i18n.choose(
                    'Признак "редактируется при распределении по подпрограммам"',
                    '«Ішкі бағдарламаларға тарату кезінде өңделеді» жалаушасы',
                    'The "edited when distributing to subprograms" flag',
                );
            },
            get unitNameKk(): string {
                return i18n.choose(
                    'Название единицы измерения на казахском',
                    'Өлшем бірлігінің қазақша атауы',
                    'Name of the unit of measurement in kazakh',
                );
            },
            get unitNameRu(): string {
                return i18n.choose(
                    'Название единицы измерения на русском',
                    'Орыс тіліндегі өлшем бірлігінің атауы',
                    'Name of the unit of measurement in russian',
                );
            },
            get width(): string {
                return i18n.choose(
                    'Ширина колонки в пикселях',
                    'Пиксельдегі баған ені',
                    'Column width in pixels',
                );
            },
        },
    },
    error: {
        get cannotLoadColumnGroups(): string {
            return i18n.choose(
                'Не удалось загрузить группы колонок',
                'Баған топтарын жүктеу сәтсіз аяқталды',
                'Cannot load column groups',
            );
        },
        get cannotLoadColumns(): string {
            return i18n.choose(
                'Не удалось загрузить колонки',
                'Бағандар жүктелмеді',
                'Cannot load columns',
            );
        },
        get cannotLoadForms(): string {
            return i18n.choose(
                'Ошибка при загрузке форм',
                'Пішінді жүктеу қатесі',
                'Error while loading forms',
            );
        },
    },
    flcWarning: {
        get items(): string {
            return i18n.choose(
                'Элементы',
                'Элементтер',
                'Elements',
            );
        },
        get equalOrderNumber(): string {
            return i18n.choose(
                'Совпадает порядковый номер',
                'Сериялық нөмірі сәйкес келеді',
                'The serial number matches',
            );
        },
        get leafGroup(): string {
            return i18n.choose(
                'Группа колонок без дочерних элементов',
                'Еншілес элементтері жоқ бағандар тобы',
                'Column group without child elements',
            );
        },
    },
    group: {
        field: {
            get id(): string {
                return 'ID';
            },
            get form(): string {
                return i18n.choose(
                    'Код формы в формате "XX-XXX", где "X" - цифра',
                    'Пішін коды «XX-XXX» пішімінде, мұнда «X» - сан',
                    'Form code in the format "XX-XXX", where "X" is a number',
                );
            },
            get hiddableCell(): string {
                return i18n.choose(
                    'Ячейка группы может быть скрыта при разных условиях ("пусто" считается равным "нет")',
                    'Топтық ұяшықты әртүрлі жағдайларда жасыруға болады («бос» «жоқ» мәніне тең деп есептеледі)',
                    'A group cell can be hidden under different conditions ("empty" is considered equal to "no")',
                );
            },
            get nameKk(): string {
                return i18n.choose(
                    'Название на казахском',
                    'Аты қазақша',
                    'Name in kazakh',
                );
            },
            get nameRu(): string {
                return i18n.choose(
                    'Название на русском',
                    'Орысша атауы',
                    'Name in russian',
                );
            },
            get orderNumber(): string {
                return i18n.choose(
                    'Порядковый номер - для сортировки групп внутри одного родителя или групп верхнего уровня',
                    'Реттік нөмірі - бір ата-аналық немесе жоғарғы деңгейдегі топтардағы топтарды сұрыптауға арналған',
                    'Sequence number - for sorting groups within one parent or top-level groups',
                );
            },
            get parent(): string {
                return i18n.choose(
                    'ID родительской группы колонок',
                    'Негізгі бағандар тобының ID',
                    'Parent column group ID',
                );
            },
        },
    },
    hierarchyItemType: {
        get columnGroup(): string {
            return i18n.choose(
                'Группа колонок',
                'Бағандар тобы',
                'Column group',
            );
        },
        get column(): string {
            return i18n.choose(
                'Колонка',
                'Баған',
                'Column',
            );
        },
    },
    get refreshHierarchy(): string {
        return i18n.choose(
            'Обновить иерархию',
            'Иерархияны жаңарту',
            'Refresh hierarchy',
        );
    },
    get selectForm(): string {
        return i18n.choose(
            'Выберите форму...',
            'Пішінді таңдаңыз ...',
            'Select form...',
        );
    },
    get title(): string {
        return i18n.choose(
            'Иерархия колонок отчетов',
            'Есептер есептерінің иерархиясы',
            'Report column hierarchy',
        );
    },
};


// region Методы для иерархии
const buildColumnItemHierarchy = (
    parent: ColumnItem.Group | null | undefined,
    colGroupMapById: Map<number, Dict.StRepFormColGroup>,
    columns: Array<Dict.StRepFormCol>,
    hierarchyDataCollector: HierarchyDataCollector,
): Array<ColumnItem> => {
    const result: Array<ColumnItem> = [];

    const parentId = parent?.data?.id ?? null;
    const parentLevel = (parent?.level ?? -1);
    const currentLevel = (parentLevel + 1);

    // Добавить группы
    colGroupMapById.forEach((columnGroup) => {
        if (columnGroup.parent === parentId) {
            const addedItem: ColumnItem.Group = {
                type: 'GROUP',
                id: columnGroup.id!!,
                orderNumber: columnGroup.orderNumber,
                data: columnGroup,
                children: [],
                level: currentLevel,
                colSpan: 1,
                flcWarnings: [],

                get title(): string {
                    return i18n.choose(
                        this.data.nameRu,
                        this.data.nameKk,
                    );
                },
            };

            result.push(addedItem);

            const newChildren = buildColumnItemHierarchy(addedItem, colGroupMapById, columns, hierarchyDataCollector);
            if (newChildren.length > 0) {
                addedItem.children = newChildren;

                let colSpan = 0;
                newChildren.forEach((child) => {
                    colSpan += child.colSpan;
                });

                addedItem.colSpan = colSpan;
            }

            if (hierarchyDataCollector.maxLevel < currentLevel) {
                hierarchyDataCollector.maxLevel = currentLevel;
            }
        }
    });

    // Добавить колонки
    if (parentId !== null) {
        columns.forEach((column) => {
            if (column.colGroup == parentId) {
                const addedItem: ColumnItem.Column = {
                    type: 'COLUMN',
                    id: column.id!!,
                    orderNumber: column.orderNumber,
                    level: currentLevel,
                    data: column,
                    colSpan: 1,
                    flcWarnings: [],

                    get title(): string {
                        return i18n.choose(
                            this.data.nameRu,
                            this.data.nameKk,
                        );
                    },
                };

                result.push(addedItem);

                if (hierarchyDataCollector.maxLevel < currentLevel) {
                    hierarchyDataCollector.maxLevel = currentLevel;
                }
            }
        });
    }

    // Отсортировать
    result.sort((a, b) => (a.orderNumber - b.orderNumber));

    return result;
};

const placeItemsToRows = (items: Array<ColumnItem>, hierarchyDataCollector: HierarchyDataCollector, level: number = 0) => {
    while (hierarchyDataCollector.itemRows.length < (level + 1)) {
        hierarchyDataCollector.itemRows.push([]);
    }

    const itemRow = hierarchyDataCollector.itemRows[level];

    items.forEach((item) => {
        itemRow.push(item);
        if ((item.type === 'GROUP') && (item.children.length > 0)) {
            placeItemsToRows(item.children, hierarchyDataCollector, level + 1);
        }
    });
};

const flc = {
    equalOrderNumber: (items: Array<ColumnItem>): void => {
        const orderNumberMap = new Map<number, Array<ColumnItem>>();
        items.forEach((item) => {
            const orderNumber = item.data.orderNumber;
            if (!orderNumberMap.has(orderNumber)) {
                orderNumberMap.set(orderNumber, []);
            }
            const itemsForOrderNumber = orderNumberMap.get(orderNumber)!!;
            itemsForOrderNumber.push(item);
        });

        orderNumberMap.forEach((itemsForOrderNumber, orderNumber) => {
            if (itemsForOrderNumber.length > 1) {
                const flcWarning: HierarchyFlcWarning.EqualOrderNumber = {
                    type: 'EQUAL_ORDER_NUMBER',
                    items: itemsForOrderNumber,
                    orderNumber,
                };
                itemsForOrderNumber.forEach((item) => {
                    item.flcWarnings.push(flcWarning);
                });
            }
        });

        orderNumberMap.clear();

        items.forEach((item) => {
            if ((item.type === 'GROUP') && (item.children.length > 0)) {
                flc.equalOrderNumber(item.children);
            }
        })
    },
    leafGroup: (items: Array<ColumnItem>): void => {
        items.forEach((item) => {
            if (item.type === 'GROUP') {
                if (item.children.length === 0) {
                    const flcWarning: HierarchyFlcWarning.LeafGroup = {
                        type: 'LEAF_GROUP',
                        items: [item],
                    };
                    item.flcWarnings.push(flcWarning);
                } else {
                    flc.leafGroup(item.children);
                }
            }
        });
    },
};
// endregion


@Component({
    components: {
        FlatButton,
        Overlay,
    },
})
export default class ReportColumnHierarchy extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    protected created() {
        // region Формы
        this.$watch('forms', () => {
            this.resetForm();
        });
        this.$watch('selectedForm', () => {
            this.refreshHierarchy();
        });
        // endregion

        // region Группы колонок (загруженные из справочника)
        this.$watch('colGroupIdList', () => {
            // Надо удалить существующие колонки
            this.columns = [];

            // Новая загрузка колонок
            this.tryReloadColumns();
        });
        // endregion
    }

    protected mounted() {
        this.tryReloadForms();
    }
    // endregion


    // region Util
    private translates = translates;

    private get loading(): boolean {
        return (
            this.loadingForms
            ||
            this.loadingColGroups
            ||
            this.loadingColumns
        );
    }

    private getReportTypesText(row: ColumnItem.Column): string {
        let result = '';

        row.data.reportTypes.forEach((reportType) => {
            let itemText: string;
            switch (reportType) {
                case 'COMMON':
                    itemText = this.translates.column.field.reportTypes.values.COMMON;
                    break;
                case 'DETAILED':
                    itemText = this.translates.column.field.reportTypes.values.DETAILED;
                    break;
                case 'DEBUG':
                    itemText = this.translates.column.field.reportTypes.values.DEBUG;
                    break;
                case 'FZP_TOTAL':
                    itemText = this.translates.column.field.reportTypes.values.FZP_TOTAL;
                    break;
                case 'FZP_CALC':
                    itemText = this.translates.column.field.reportTypes.values.FZP_CALC;
                    break;
                case 'FZP_NA':
                    itemText = this.translates.column.field.reportTypes.values.FZP_NA;
                    break;
                default:
                    itemText = reportType ?? '';
                    break;
            }

            if (result.length > 0) {
                result += ', ';
            }
            result += itemText;
        });

        return result;
    }
    // endregion


    // region Формы
    private forms: Array<string> = [];
    private loadingForms: boolean = false;
    private selectedForm: (string | null) = null;

    private get formOptions(): Array<Comp.DropdownItemDef<string | null>> {
        const result: Array<Comp.DropdownItemDef<string | null>> = [{
            value: null,
            text: this.translates.selectForm,
        }];

        this
            .forms
            .forEach((formValue) => {
                result.push({
                    value: formValue,
                    text: formValue,
                });
            });

        return result;
    }

    private reloadForms(): void {
        if (this.loadingForms) {
            console.error('Cannot reload forms - another loading is running');
            return;
        }

        this.loadingForms = true;

        this.request<Array<string>>(
            {
                method: 'GET',
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col_group/forms',
            },
            (data) => {
                this.forms = data;
            },
            () => {
                return this.translates.error.cannotLoadForms;
            },
            () => {
                this.loadingForms = false;
            },
        );
    }

    private tryReloadForms(): void {
        if (!this.loadingForms) {
            this.reloadForms();
        }
    }

    private resetForm() {
        const selectedForm = this.selectedForm;

        if (selectedForm === null) {
            return;
        }

        let formExists = false;
        for (const formValue of this.forms) {
            if (formValue === selectedForm) {
                formExists = true;
                break;
            }
        }

        if (!formExists) {
            this.selectedForm = null;
        }
    }
    // endregion


    // region Группы колонок (загруженные из справочника)
    private loadingColGroups = false;
    private colGroups: Array<Dict.StRepFormColGroup> = [];

    private get colGroupMapById(): Map<number, Dict.StRepFormColGroup> {
        const result: Map<number, Dict.StRepFormColGroup> = new Map();

        this.colGroups.forEach((colGroup) => {
            const id = colGroup.id;
            if (id !== null) {
                result.set(id, colGroup);
            }
        });

        return result;
    }

    private get colGroupIdList(): Array<number> {
        return [...this.colGroupMapById.keys()];
    }

    private reloadColGroups(): void {
        if (this.loadingColGroups) {
            console.error('Cannot reload column groups - another loading is running');
            return;
        }

        const selectedForm = this.selectedForm;
        if (selectedForm === null) {
            console.error('Cannot reload column groups - selected form is null');
            return;
        }

        this.loadingColGroups = true;

        const searchConfig = {
            itemsPerPage: javaMaxInteger,
            formSet: [selectedForm],
        };

        this.request<Utils.PaginationList<Dict.StRepFormColGroup>>(
            {
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col_group/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                this.colGroups = data.items;
            },
            () => (this.translates.error.cannotLoadColumnGroups),
            () => {
                this.loadingColGroups = false;
            },
        );
    }

    private tryReloadColGroups(): void {
        if ((!this.loadingColGroups) && (this.selectedForm !== null)) {
            this.reloadColGroups();
        }
    }
    // endregion


    // region Колонки (загруженные из справочника)
    private loadingColumns = false;
    private columns: Array<Dict.StRepFormCol> = [];

    private get columnIdList(): Array<number> {
        const result: Array<number> = [];

        this.columns.forEach((column) => {
            const id = column.id;
            if (id !== null) {
                result.push(id);
            }
        });

        return result;
    }

    private reloadColumns(): void {
        if (this.loadingColumns) {
            console.error('Cannot reload columns - another loading is running');
            return;
        }

        const colGroupIdList = this.colGroupIdList;
        if (colGroupIdList.length === 0) {
            console.error('Cannot reload columns - column group ID list is empty');
            return;
        }

        const searchConfig = {
            itemsPerPage: javaMaxInteger,
            colGroupSet: [...colGroupIdList],
        };

        this.loadingColumns = true;

        this.request<Utils.PaginationList<Dict.StRepFormCol>>(
            {
                url: '/api/budget/staffing_table/dict/dict_st_rep_form_col/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                this.columns = data.items;
            },
            () => (this.translates.error.cannotLoadColumns),
            () => {
                this.loadingColumns = false;
            },
        );
    }

    private tryReloadColumns(): void {
        if ((!this.loadingColumns) && (this.colGroupIdList.length > 0)) {
            this.reloadColumns();
        }
    }
    // endregion


    // region Элементы иерархии
    private modalItemGroup: ColumnItem.Group | null = null;
    private modalItemColumn: ColumnItem.Column | null = null;

    private refreshHierarchy(): void {
        // Удаление существующих групп и колонок
        this.columns = [];
        this.colGroups = [];

        // Новая загрузка групп колонок
        this.tryReloadColGroups();
    }

    private get hierarchy(): Hierarchy {
        const hierarchyDataCollector: HierarchyDataCollector = {
            maxLevel: 0,
            itemRows: [],
        }

        const items = buildColumnItemHierarchy(null, this.colGroupMapById, this.columns, hierarchyDataCollector);
        placeItemsToRows(items, hierarchyDataCollector);

        flc.equalOrderNumber(items);
        flc.leafGroup(items);

        return {
            maxLevel: hierarchyDataCollector.maxLevel,
            items,
            itemRows: hierarchyDataCollector.itemRows,
        };
    }

    private get hierarchyMaxLevel(): number {
        return this.hierarchy.maxLevel;
    }

    private get hierarchyColSpanSum(): number {
        let result = 0;

        this.hierarchy.items.forEach((item) => {
            result += item.colSpan;
        });

        return result;
    }

    private get hierarchyItemRows(): Array<Array<ColumnItem>> {
        return this.hierarchy.itemRows;
    }

    private getHierarchyItemRowSpan(item: ColumnItem): number {
        if ((item.type === 'GROUP') && (item.children.length > 0)) {
            return 1;
        } else {
            return (this.hierarchyMaxLevel - item.level + 1);
        }
    }

    private getHierarchyItemVariant(item: ColumnItem): ('primary' | 'secondary' | 'warning') {
        if (item.flcWarnings.length > 0) {
            return 'warning';
        } else if (item.type === 'GROUP') {
            return 'primary';
        } else {
            return 'secondary';
        }
    }

    private getHierarchyItemStyle(item: ColumnItem): Record<string, unknown> {
        const result: Record<string, unknown> = { cursor: 'pointer' };

        if (item.type === 'GROUP') {
            if (item.children.length === 0) {
                result.width = '85px';
            }
        } else {
            result.width = `${item.data.width}px`;
        }

        return result;
    }

    private onHierarchyItemClick(item: ColumnItem): void {
        if (item.type === 'GROUP') {
            this.modalItemGroup = item;
        } else {
            this.modalItemColumn = item;
        }
    }
    // endregion
}
